/**
 * Component Entry
 *
 */

import Tag from './Tag'
export default Tag
export * from './Tag'
